import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Collapse from '@material-ui/core/Collapse';
import styled from 'styled-components';
import { fontFamily, fontSize } from '../../../constants/text';
import { colors } from '../../../constants/colors';
import StarSelector from '../../SolvPatternLibrary/StarSelector';

export const PRIMARY_RATING = 'primary rating';

const FLAVOR_COPY = {
  1: 'worst ever',
  2: 'not good',
  3: 'just ok',
  4: 'I liked it',
  5: 'it was great!',
};

const Root = styled.div`
  text-align: center;
  padding: 26px 20px;
`;

const Title = styled.h1`
  margin: 0 auto 20px;
  display: block;
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.large};
  color: ${colors.blueMonday};
`;

const FlavorText = styled(Collapse)`
  margin: 20px auto 0;
  font-family: ${fontFamily.book};
  font-size: ${fontSize.medium};
  color: ${colors.peaches};
`;

export default class PrimaryRatingSelector extends PureComponent {
  static propTypes = {
    maryMagicSurvey: PropTypes.object,
    onChange: PropTypes.func,
  };

  onChangeInterpreter = value => {
    const { onChange } = this.props;
    onChange({ value, genre: PRIMARY_RATING });
  };

  render() {
    const { maryMagicSurvey } = this.props;
    const flavorCopy = FLAVOR_COPY[maryMagicSurvey[PRIMARY_RATING]];
    return (
      <Root data-testid="primary-rating-selector-root">
        <Title>Overall, how was your experience with Solv?</Title>
        <StarSelector
          rating={maryMagicSurvey[PRIMARY_RATING]}
          onChange={this.onChangeInterpreter}
          starWidth={43}
        />
        <FlavorText in={!!flavorCopy} timeout="auto">
          {flavorCopy}
        </FlavorText>
      </Root>
    );
  }
}
